import PageableBase from 'app/collections/pageable_base';
import { appUrl } from 'utils/wrappers';
import Insurance from 'app/models/insurance';

export default PageableBase.extend({
  model: Insurance,
  key: 'insurances',
  url: appUrl('insurances'),

  initialize(models, { apiMode, dateRange }) {
    this.apiMode = apiMode;
    this.dateRange = dateRange;

    this.listenTo(this.dateRange, 'change', this.resetToFirstPage);
    this.listenTo(this.apiMode, 'change:mode', this.resetToFirstPage);
  },

  paramsForFetch() {
    return {
      mode: this.apiMode.get('mode'),
      start_datetime: this.dateRange.getStartDatetimeForParamIso(),
      end_datetime: this.dateRange.getDayAfterEndDatetimeForParamIso(),
    };
  },
});



// WEBPACK FOOTER //
// ./app/collections/insurances.js